module.exports = __webpack_public_path__ + "static/heatmap-00f2745ca83989e89b0241285d34c5b3.png";